export const generateXMLSitemap = async (): Promise<string> => {
  const baseUrl = 'https://www.carolinatrophyroofs.com';
  
  // Get the actual current date
  const now = new Date();
  const currentDate = now.toISOString().split('T')[0];
  
  // Debug logging to see what date we're actually getting
  console.log('Current date for sitemap:', currentDate);
  console.log('Full date object:', now);
  
  // Define all actual pages found in the codebase
  const pages = [
    // Main pages
    { url: '/', priority: '1.0', changefreq: 'weekly' },
    { url: '/about', priority: '0.9', changefreq: 'monthly' },
    { url: '/contact', priority: '0.9', changefreq: 'monthly' },
    { url: '/services', priority: '0.9', changefreq: 'weekly' },
    { url: '/blog', priority: '0.8', changefreq: 'weekly' },
    { url: '/locations', priority: '0.8', changefreq: 'monthly' },
    { url: '/resources', priority: '0.7', changefreq: 'monthly' },
    { url: '/gallery', priority: '0.7', changefreq: 'monthly' },
    { url: '/financing', priority: '0.7', changefreq: 'monthly' },
    { url: '/quote', priority: '0.8', changefreq: 'monthly' },
    { url: '/service-areas', priority: '0.8', changefreq: 'monthly' },
    { url: '/brands', priority: '0.7', changefreq: 'monthly' },
    { url: '/careers', priority: '0.6', changefreq: 'monthly' },
    { url: '/faq', priority: '0.7', changefreq: 'monthly' },
    { url: '/book-inspection', priority: '0.8', changefreq: 'monthly' },
    { url: '/design-your-roof', priority: '0.7', changefreq: 'monthly' },
    { url: '/photo-gallery', priority: '0.6', changefreq: 'monthly' },
    { url: '/photo-album', priority: '0.6', changefreq: 'monthly' },
    { url: '/roof-life-expectancy-report', priority: '0.7', changefreq: 'monthly' },
    { url: '/roof-installations-and-materials', priority: '0.7', changefreq: 'monthly' },
    
    // Special long URL pages
    { url: '/best-roofer-near-me-greenville-nc', priority: '0.8', changefreq: 'monthly' },
    { url: '/professional-church-steeple-repair-and-replacement-services-in-raleigh-nc-and-surrounding-areas', priority: '0.7', changefreq: 'monthly' },
    
    // Service pages
    { url: '/services/installation', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/repair', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/maintenance', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/inspection', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/emergency', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/commercial', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/residential', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/storm-damage', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/commercial-roofing', priority: '0.8', changefreq: 'monthly' },
    { url: '/services/residential-roofing', priority: '0.8', changefreq: 'monthly' },
    
    // Specialty service pages
    { url: '/services/metal-roofing', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/slate-roofing', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/tile-roofing', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/flat-roofing', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/gutter-services', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/siding', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/solar-installation', priority: '0.7', changefreq: 'monthly' },
    { url: '/services/waterproofing', priority: '0.7', changefreq: 'monthly' },
    { url: '/specialty/roof-coating', priority: '0.7', changefreq: 'monthly' },
    { url: '/specialty/church-steeple-repair', priority: '0.7', changefreq: 'monthly' },
    
    // Resource pages
    { url: '/resources/roofing-materials', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/maintenance-tips', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/insurance-claims', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/warranty-information', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/energy-efficiency', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/storm-damage', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/choosing-contractor', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/cost-factors', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/understanding-roofing-materials', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/insurance-claim-process', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/insurance-claim-process-page', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/manufacturer-warranties', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/roof-replacement-process', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/roof-ventilation-guide', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/roofing-costs-faq', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/roofing-materials-faq', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/warranty-registration', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/working-with-adjusters', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/workmanship-warranty', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/identify-roof-damage', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/documentation-requirements', priority: '0.7', changefreq: 'monthly' },
    { url: '/resources/general-roofing-faq', priority: '0.7', changefreq: 'monthly' },
    
    // Legal pages
    { url: '/privacy-policy', priority: '0.3', changefreq: 'yearly' },
    { url: '/terms-of-service', priority: '0.3', changefreq: 'yearly' },
    { url: '/cookie-policy', priority: '0.3', changefreq: 'yearly' },
    { url: '/privacy', priority: '0.3', changefreq: 'yearly' },
    { url: '/sms-terms', priority: '0.3', changefreq: 'yearly' },
    
    // All location pages
    { url: '/locations/afton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/ahoskie', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/airlie', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/alert', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/angier', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/apex', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/archer-lodge', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/asheville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/aulander', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/aurora', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/autryville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/avon', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/ayden', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/bailey', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/bath', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/battleboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/bellarthur', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/belhaven', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/benson', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/bethel', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/beulaville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/black-creek', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/broadway', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/bunn', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/burgaw', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/buxton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/calypso', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/cary', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/castalia', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/centerville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/chapel-hill', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/chinquapin', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/chocowinity', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/clayton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/clinton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/coats', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/colerain', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/columbia', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/conetoe', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/conway', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/cove-city', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/creedmoor', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/creswell', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/deep-run', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/dortches', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/dover', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/dudley', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/dunn', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/durham', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/edenton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/elizabeth-city', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/elizabethtown', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/elm-city', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/enfield', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/engelhard', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/erwin', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/eureka', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/faison', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/falkland', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/farmville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/fayetteville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/fountain', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/four-oaks', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/franklinton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/fremont', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/fuquay-varina', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/garland', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/garner', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/garysburg', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/gaston', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/gatesville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/godwin', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/gold-point', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/goldsboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/greenville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/greenville-nc', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/grifton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/grimesland', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/halifax', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hamilton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/harrells', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hassell', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hatteras', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/havelock', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/henderson', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hertford', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hickory', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hobgood', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/holly-springs', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hollister', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/hookerton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/jackson', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/jacksonville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/jamesville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/kelford', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/kenansville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/kenly', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/kill-devil-hills', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/kinston', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/kitty-hawk', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/knightdale', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/la-grange', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/leggett', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/lewiston', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/lillington', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/littleton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/louisburg', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/lucama', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/lumberton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/macclesfield', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/macon', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/magnolia', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/manteo', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/maysville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/micro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/middlesex', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/momeyer', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/morehead-city', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/morrisville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/mount-olive', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/murfreesboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/nags-head', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/nashville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/new-bern', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/newton-grove', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/norlina', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/oak-city', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/ocracoke', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/oxford', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pantego', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pikeville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pine-level', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pinetops', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pink-hill', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pittsboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/plymouth', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/pollocksville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/powellsville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/princeton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/raleigh', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/red-oak', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/rich-square', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/richlands', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/roanoke-rapids', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/robersonville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/rocky-mount', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/rocky-mount-nc', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/rodanthe', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/rolesville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/roper', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/rose-hill', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/roseboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/salemburg', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/salvo', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/sanford', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/saratoga', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/scotland-neck', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/seaboard', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/selma', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/seven-springs', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/sharpsburg', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/sims', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/smithfield', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/snow-hill', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/speed', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/spring-hope', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/stantonsburg', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/stokes', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/swan-quarter', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/swansboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/tarboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/teachey', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/thelma', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/trenton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/turkey', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/tyner', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/vanceboro', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/vaughan', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wade', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wake-forest', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wallace', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/walstonburg', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wanchese', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/warden', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/warrenton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/warsaw', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/washington', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/waves', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/waynesville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/weldon', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wendell', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/whitakers', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/whiteville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/williamston', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wilmington', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/wilson', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/windsor', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/winfall', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/winterville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/winton', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/woodland', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/yanceyville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/youngsville', priority: '0.6', changefreq: 'monthly' },
    { url: '/locations/zebulon', priority: '0.6', changefreq: 'monthly' },
    
    // Utility/sitemap pages
    { url: '/sitemap', priority: '0.3', changefreq: 'daily' },
    { url: '/sitemap.xml', priority: '0.1', changefreq: 'daily' },
    { url: '/sitemap-xml', priority: '0.1', changefreq: 'daily' },
    { url: '/sitemap-xml-feed', priority: '0.1', changefreq: 'daily' },
  ];

  // Generate XML sitemap
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
  xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"\n`;
  xml += `        xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\n`;
  xml += `        xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9\n`;
  xml += `        http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">\n`;

  // Add each page to the sitemap
  pages.forEach(page => {
    xml += `  <url>\n`;
    xml += `    <loc>${baseUrl}${page.url}</loc>\n`;
    xml += `    <lastmod>${currentDate}</lastmod>\n`;
    xml += `    <changefreq>${page.changefreq}</changefreq>\n`;
    xml += `    <priority>${page.priority}</priority>\n`;
    xml += `  </url>\n`;
  });

  xml += `</urlset>`;

  return xml;
};

// Function to generate robots.txt content
export const generateRobotsTxt = (): string => {
  const baseUrl = 'https://www.carolinatrophyroofs.com';
  
  return `User-agent: *
Allow: /

# Sitemap
Sitemap: ${baseUrl}/sitemap.xml

# Disallow admin pages
Disallow: /admin/

# Disallow private pages
Disallow: /dashboard/
Disallow: /login/
Disallow: /register/

# Allow all other pages
Allow: /
Allow: /about
Allow: /contact
Allow: /services
Allow: /locations
Allow: /blog
Allow: /resources
Allow: /gallery
Allow: /financing
Allow: /quote
Allow: /service-areas

# Crawl-delay
Crawl-delay: 1`;
};

// Function to preload critical resources for better performance
export const preloadCriticalResources = () => {
  // Preload critical fonts
  const fonts = [
    'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap',
    'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',
    'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap'
  ];
  
  fonts.forEach(font => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = font;
    link.as = 'style';
    document.head.appendChild(link);
  });
  
  // Preload critical images
  const criticalImages = [
    '/lovable-uploads/2f5a66d3-a9ff-41b4-888b-9060533e361f.png' // Logo
  ];
  
  criticalImages.forEach(src => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = src;
    link.as = 'image';
    document.head.appendChild(link);
  });
};
